import Lottie from "react-lottie";
import animationData from "lotties/loading.json";

const Spinner = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <div className={`cs_spinner`}>
      <Lottie options={defaultOptions} height={77} width={77} />
      <span className="">Loading...</span>
    </div>
  );
};

export default Spinner;
